<template>
    <defNavBar title="Ares - Update multiple night prices" :info="[
          {label: 'Accommodation:', value: hspt.accommodation}, 
          {label: 'Contract: ', value: hspt.cttptaal_oms},
          {label: 'Arrivals: ', value: `${this.hspt.start_date} - ${this.hspt.end_date}`}]" :home=false />
</template>

<script>

  import defNavBar from '@/components/ui/navbars/navbar.vue';

  export default {
    props: {
      hspt: Object
    },
    components: {
      defNavBar,
    },          
  }

</script>
